import { cx, hoc } from '#packages/util';
import React from 'react';
import { Text } from '@wix/wix-base-ui';
import { AUTOMATION_IDS } from '../constants';
import styles from './SectionsDropZone.scss';
import {
  mapStateToProps,
  type SectionsDropZoneStateProps,
} from './SectionsDropZoneMappers';
import { useTranslation } from 'react-i18next';

export interface SectionDropZoneOwnProps {
  style: React.CSSProperties;
  isDragging: boolean;
  shouldDisplayStaticDropZone: boolean;
}

interface SectionDropZoneProps
  extends SectionDropZoneOwnProps,
    SectionsDropZoneStateProps {}

const SectionsDropZoneComponent: React.FC<SectionDropZoneProps> = ({
  style,
  left,
  width,
  isDragging,
  shouldDisplayStaticDropZone,
}) => {
  const { t } = useTranslation();
  const addDragText = shouldDisplayStaticDropZone
    ? t('section_add_from_emptystate_placeholder')
    : t('section_add_drag_placeholder');

  return (
    <div
      className={cx(styles.sectionsDropZoneWrapper, {
        [styles.isDragging]: isDragging,
      })}
      style={{
        left,
        width,
        ...style,
      }}
      data-hook={AUTOMATION_IDS.DROPZONE}
    >
      <div className={styles.sectionsDropZoneBody}>
        <Text size="small" shouldTranslate={false} enableEllipsis={false}>
          <span className={styles.sectionsDropZoneBody__text}>
            {addDragText}
          </span>
        </Text>
      </div>
    </div>
  );
};

export const SectionsDropZone = hoc.connect(
  hoc.STORES.EDITOR_API,
  mapStateToProps,
)(SectionsDropZoneComponent);
